<script lang="ts">
	import type { BreadcrumbLink } from '$lib/features/_other/breadcrumbLink';
	import type { ClassValue } from 'svelte/elements';

	interface TextColours {
		NO_OPACITY: ClassValue;
		OPACITY_85: ClassValue;
		OPACITY_70: ClassValue;
		OPACITY_40: ClassValue;
		LINK: ClassValue;
	}

	const {
		items,
		textColour = 'dark',
		classes
	}: { items: BreadcrumbLink[]; textColour?: 'dark' | 'light' | 'white'; classes?: ClassValue } = $props();

	const textColourClass = $derived.by<TextColours>(() => {
		switch (textColour) {
			case 'dark':
				return {
					NO_OPACITY: 'text-base-100',
					OPACITY_85: 'text-base-100/85',
					OPACITY_70: 'text-base-100/70',
					OPACITY_40: 'text-base-100/40',
					LINK: 'text-base-100/70 hover:text-base-100'
				};
			case 'light':
				return {
					NO_OPACITY: 'text-base-content',
					OPACITY_85: 'text-base-content/85',
					OPACITY_70: 'text-base-content/70',
					OPACITY_40: 'text-base-content/40',
					LINK: 'text-base-content/70 hover:text-base-content'
				};
			case 'white':
				return {
					NO_OPACITY: 'text-white',
					OPACITY_85: 'text-white/85',
					OPACITY_70: 'text-white/70',
					OPACITY_40: 'text-white/40',
					LINK: 'text-white/70 hover:text-white'
				};
		}
	});
</script>

<nav class={classes} aria-label="Breadcrumb">
	<ol
		class="flex scrollbar-none flex-nowrap items-center gap-x-2 overflow-x-auto font-mono text-xs tracking-widest whitespace-nowrap [&::-webkit-scrollbar]:hidden {textColourClass.OPACITY_70}"
	>
		{#each items as item, i (item.nav.routeId)}
			{const isLast = $derived<boolean>(i === items.length - 1)}
			{const isSecondToLast = $derived<boolean>(i === items.length - 2)}
			{const clickable = $derived<boolean>((item.clickable ?? true) && !isLast)}

			<li class="flex shrink-0 items-center gap-x-2">
				{#if clickable}
					<a
						class="{textColourClass.OPACITY_70} transition-colors duration-150 hover:{textColourClass.NO_OPACITY}"
						href={`/${item.nav.href}`}
						data-sveltekit-preload-data={item.nav.preloadData}
						data-sveltekit-preload-code={item.nav.preloadCode}
					>
						{item.label.toUpperCase()}
					</a>
				{:else}
					{const isCurrent = $derived<boolean>(isLast)}
					<span class={isCurrent ? `font-bold ${textColourClass.NO_OPACITY}` : textColourClass.OPACITY_70}>
						{item.label.toUpperCase()}
					</span>
				{/if}
			</li>

			{#if !isLast && !isSecondToLast}
				<li aria-hidden="true" class="{textColourClass.OPACITY_40} select-none">/</li>
			{:else if isSecondToLast}
				<li aria-hidden="true" class="font-bold {textColourClass.OPACITY_85} select-none">/</li>
			{/if}
		{/each}
	</ol>
</nav>
